export const HEAD_CELL_LINES_NUMBER_BY_VIEW = {
  default: 3,
  fancy: 1,
} as const;

export const HEAD_CELL_FONT_SIZE_BY_VIEW = {
  default: 'secondary',
  fancy: 'caption',
} as const;
